export default __webpack_public_path__ + "static/media/word-cloud.ac893743.gif";